module.exports = __webpack_public_path__ + "static/media/student-photo-save.1d5dc71e.png";